module.exports = __webpack_public_path__ + "img/ctrl-s-dagger-1.d734fb83.svg";